export default __webpack_public_path__ + "static/media/beep1.e6e927d7.mp3";